import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import {useWindowSize} from '../../../hooks/useWindowSize'

const LayoutContentRightBase = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: ${p =>
    p.headerPresent
      ? p.theme.sizes.headerHeight +
        'px ' +
        (p.mainHeight -
          p.theme.sizes.headerHeight -
          p.theme.sizes.footerHeight) +
        'px ' +
        p.theme.sizes.footerHeight +
        'px'
      : p.mainHeight -
        p.theme.sizes.footerHeight +
        'px ' +
        p.theme.sizes.footerHeight +
        'px'};
`

const LayoutMain = styled.div`
  display: grid;
  grid-template-columns: ${p => p.renderPlaceHolderLeft && '1fr'} auto ${p =>
      p.renderPlaceHolderRight && '1fr'};
`

const LayoutContentRight = ({
  renderFooter,
  renderHeader,
  renderMain,
  renderPlaceHolderLeft,
  renderPlaceHolderRight
}) => {
  const {innerHeight} = useWindowSize()

  return (
    <LayoutContentRightBase
      headerPresent={renderHeader && renderHeader() !== null}
      mainHeight={innerHeight}
    >
      {renderHeader && renderHeader()}
      <LayoutMain
        renderPlaceHolderLeft={renderPlaceHolderLeft}
        renderPlaceHolderRight={renderPlaceHolderRight}
      >
        {renderPlaceHolderLeft && renderPlaceHolderLeft()}
        {renderMain()}
        {renderPlaceHolderRight && renderPlaceHolderRight()}
      </LayoutMain>
      {renderFooter && renderFooter()}
    </LayoutContentRightBase>
  )
}

LayoutContentRight.propTypes = {
  renderFooter: PropTypes.func,
  renderHeader: PropTypes.func,
  renderMain: PropTypes.func.isRequired,
  renderPlaceHolderLeft: PropTypes.func,
  renderPlaceHolderRight: PropTypes.func
}

export default LayoutContentRight
